import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMagicWand: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"magic-wand, magic stick, star"} maskId="square-filled-radius-0-stroke-1-IconMagicWand"><path d="M10.2311 2.60254L10.6714 8.3036L5.80031 11.2984L10.7889 12.5037L2.79297 20.4996L3.50007 21.2067L11.496 13.2108L12.7014 18.1994L15.6961 13.3284L21.3972 13.7687L17.69 9.41523L19.8705 4.12927L14.5845 6.30976L10.2311 2.60254Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMagicWand;
